import { Button, Stack } from "@mui/material";
import LoadingButton from "src/components/Buttons/LoadingButton";

interface Props {
  generate: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
  refetch: () => void;
  isLoading: boolean;
  generated: boolean;
  requestSuggestion: boolean;
}

const MessageSuggestion = ({
  generate,
  isLoading,
  onClose,
  refetch,
  generated,
  requestSuggestion,
}: Props) => {
  return generated && requestSuggestion ? (
    <Stack direction={"row"} gap={1}>
      <Button
        variant="secondary"
        sx={{ height: "min-content", mt: 4 }}
        onClick={onClose}
      >
        Close
      </Button>
      <Button
        variant="alternate"
        sx={{ height: "min-content", mt: 4 }}
        onClick={() => refetch()}
      >
        New suggestion
      </Button>
    </Stack>
  ) : (
    <LoadingButton
      loading={isLoading}
      sx={{ height: "min-content", mt: 4, width: "fit-content" }}
      onClick={generate}
    >
      Suggestion
    </LoadingButton>
  );
};

export default MessageSuggestion;
